const initialState = {
  loading: false,
  setting: null,
  errors: {},
};

const holidayPromoSettings = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'HOLIDAY_PROMO_SETTINGS_REQUEST':
    case 'UPDATE_HOLIDAY_PROMO_SETTINGS_REQUEST':
      return { ...state, loading: true, errors: {} };
    case 'HOLIDAY_PROMO_SETTINGS_SUCCESS':
    case 'UPDATE_HOLIDAY_PROMO_SETTINGS_SUCCESS':
      return {
        ...state,
        loading: false,
        setting: payload.holiday_promo_setting,
        errors: {},
      };
    case 'HOLIDAY_PROMO_SETTINGS_FAILURE':
    case 'UPDATE_HOLIDAY_PROMO_SETTINGS_FAILURE':
      return { ...state, loading: false, errors: (payload && payload.errors) || {} };
    default:
      return state;
  }
};

export const getHolidayPromoSetting = state => state.setting;
export const getHolidayPromoSettingLoading = state => state.loading;
export const getHolidayPromoSettingErrors = state => state.errors;

export default holidayPromoSettings;



// WEBPACK FOOTER //
// ./client/app/reducers/holiday_promo_settings.js